import { Box } from "@mui/material";
import { AnimatePresence } from "motion/react";
import { useSnapshot } from "valtio";
import { ToastItem } from "src/components-mui/common/toast-stack/toast-item";
import { toastStore } from "src/stores/toast-store";

export const ToastStack = () => {
    const { toasts } = useSnapshot(toastStore);

    return (
        <Box
            role="status"
            aria-live="polite"
            sx={{
                position: "fixed",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: theme => theme.customZIndex!.toast,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pointerEvents: "none",
                width: "100%",
            }}
        >
            <AnimatePresence initial={false}>
                {toasts.map(toast => (
                    <ToastItem key={toast.id} toast={toast} />
                ))}
            </AnimatePresence>
        </Box>
    );
};
